<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="onFileSelect($event)" [multiple]="false"
	[disabled]="disabled" [ngClass]="cls">
	<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
		<div style="text-align: center;">
			@if(fileUploadLoader){
			<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
			}@else{
			<fa-icon role="button" [icon]="['fas', 'upload']" (click)="disabled?null:openFileSelector()"
				matTooltip="Upload File"></fa-icon>
			}
		</div>
	</ng-template>
</ngx-file-drop>
<p *ngFor="let msg of fileMsg" class="text-center" [ngClass]="msg.isInvalid?'text-danger':''">
	<span>
		{{msg.msg}}
	</span>
</p>
<ng-template #myModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">
			<strong>
				Crop Image
			</strong>
		</h4>
		<button type="button" class="btn-close" (click)="closeModal()"></button>
	</div>
	<div class="modal-body">
		<div class="row g-0">
			<div class="col-6 p-2 text-center border-end">
				@if(showCropper){
				<p>
					<strong class="underline">
						Selected Image
					</strong>
				</p>
				<div class="btn-group" role="group">
					<button type="button" class="btn btn-primary btn-sm" (click)="rotate(90)" matTooltip="Rotate right">
						<fa-icon [icon]="['fas','redo']"></fa-icon>
					</button>
					<button type="button" class="btn btn-primary btn-sm" (click)="rotate(-90)" matTooltip="Rotate left">
						<fa-icon [icon]="['fas','undo']"></fa-icon>
					</button>
					<button type="button" class="btn btn-primary btn-sm" (click)="flipHorizontal()"
						matTooltip="Flip Horizontal">
						<fa-icon [icon]="['fas','arrow-left']"></fa-icon>
						<fa-icon [icon]="['fas','arrow-right']"></fa-icon>
					</button>
				</div>
				<!-- <image-cropper #imageCropper [imageFile]="file" format="png" (imageCropped)="imageCropped($event)"
					(loadImageFailed)="loadImageFailed()" [maintainAspectRatio]="false" [aspectRatio]="1/1"
					[transform]="transform" [containWithinAspectRatio]="true" [allowMoveImage]="true"
					[alignImage]="'center'">
				</image-cropper> -->
				<image-cropper #imageCropper [imageFile]="file" format="jpeg" (imageCropped)="imageCropped($event)"
					(loadImageFailed)="loadImageFailed()" [maintainAspectRatio]="false" [aspectRatio]="1/1"
					[transform]="transform" [containWithinAspectRatio]="true" [allowMoveImage]="true"
					[alignImage]="'center'">
				</image-cropper>
				}
			</div>
			<div class="col-6 p-2 text-center border-start">
				<p>
					<strong class="underline">
						Cropped Image
					</strong>
				</p>
				<img [ngStyle]="croppedDiam" class="border" [src]="croppedImage" />
			</div>
		</div>
	</div>
	<div class="modal-footer text-center d-block">
		<button type="button" class="btn btn-sm btn-success" (click)="saveCroppedImage()">
			Done
		</button>
		<button type="button" class="btn btn-sm btn-light" (click)="closeModal()">
			Cancel
		</button>
	</div>
</ng-template>